import PropTypes from "prop-types";

const children = PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])

export { children };
